import Vue from "vue";
import store from "../store";
import "../common.js";
import RegistrationForm from "../components/RegistrationForm";

import "../css/pages/registration.scss";

Vue.config.productionTip = false;

document.addEventListener("DOMContentLoaded", () => {
  new Vue({
    store,
    render: h => h(RegistrationForm),
  }).$mount(".js-registration-form");
});
